export default "__VITE_ASSET__B6Xm3tBG__"